import { useEffect, useRef } from 'react';

export const useNotificationRefresh = (refetch: (() => void) | undefined) => {
  const refetchRef = useRef(refetch);
  refetchRef.current = refetch;

  useEffect(() => {
    const handleRefresh = () => refetchRef.current?.();
    window.addEventListener('flowio:refresh-notifications', handleRefresh);
    return () => window.removeEventListener('flowio:refresh-notifications', handleRefresh);
  }, []);
};
